export enum ReportType {
  Quarterly = 'Quarterly',
  Annual = 'Annual',
  Other = 'Other',
  Weekly = 'Weekly',
}
